export const keys = {
  businessOccupancy: {
    businessTypes: {
      title: 'What kind of businesses operate in your building?',
      choices: {
        restaurant: 'Restaurant, bar, coffee shop or pub',
        store: 'Store (e.g. clothing, bookstore, electronics)',
        office: 'Office (e.g. travel agency, real estate agency)',
        gasStation: 'Gas station or auto repair garage',
        hazardousMaterialsHandler: 'Business handling hazardous materials',
        other: 'Other',
      },
    },
  },
};
export default keys;

export type TranslationKeys = typeof keys;
